import React, { useEffect } from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		flex: "none",
		background: theme.mode === "light"
			? "linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%)"
			: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
		borderBottom: "1px solid " + (theme.mode === "light" ? "rgba(37,99,235,0.15)" : "rgba(96,165,250,0.18)"),
		boxShadow: theme.mode === "light"
			? "0 2px 8px rgba(15,23,42,0.06)"
			: "0 2px 8px rgba(0,0,0,0.22)",
		height: "72px",
		[theme.breakpoints.down("sm")]: {
			flexWrap: "wrap",
			height: "max-content",
		},
	},
	backBtn: {
		color: theme.mode === "light" ? "#2563eb" : "#60a5fa",
		minWidth: 40,
		borderRadius: 10,
		marginLeft: 6,
		alignSelf: "center",
		flexShrink: 0,
		"&:hover": {
			backgroundColor: theme.mode === "light" ? "rgba(37,99,235,0.08)" : "rgba(96,165,250,0.12)",
		},
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
				>
					<Button color="primary" onClick={handleBack} className={classes.backBtn}>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
